<div fxLayout='row' fxLayoutAlign='center center' fxLayoutGap='20px'>
    <button mat-raised-button color='primary' (click)='showFilePicker()'>
        {{getFileName()}}
    </button>
    <mat-form-field *ngIf='showHole' fxFlex="50%">
        <mat-label>Assign to:</mat-label>
        <mat-select placeholder="Assign to:" [(ngModel)]="assigned_to_hole">
            <mat-option *ngFor="let hole of allHoles" [value]='hole.value'>
                {{hole.desc}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <button mat-raised-button color='accent' (click)='uploadFile()' [disabled]='!fileToUpload'>Upload
        <i class='fa fa-spinner fa-spin' *ngIf='uploading'></i>
    </button>
</div>
<input type='file' #file style="display:none" (change)='setFile()' />